import { Routes, Route, BrowserRouter } from "react-router-dom";
import { SupabaseAuthProvider } from "./context/SupabaseAuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import LoginPage from "./pages/LoginPage";
import Header from "./components/Header";
import VideoUploadPage from "./pages/VideoUploadPage";
import TenantsPage from "./pages/TenantsPage";
import AddTenantPage from "./pages/AddTenantPage";
import VideosPage from "./pages/VideosPage";
import { NotificationProvider } from "./context/NotificationContext";

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SupabaseAuthProvider>
          <Routes>
            {/* Route di login (non protetta) */}
            <Route path="/login" element={<LoginPage />} />

            {/* Route protette */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <NotificationProvider>
                    <div className="min-h-screen bg-gray-50">
                      <Header />
                      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                        <Routes>
                          <Route path="/" element={<VideosPage />} />
                          <Route path="/upload" element={<VideoUploadPage />} />
                          
                          {/* Route per gestione tenant */}
                          <Route path="/tenants" element={<TenantsPage />} />
                          <Route path="/tenants/add" element={<AddTenantPage />} />
                          
                          {/* Route per visualizzazione video API */}
                          <Route path="/videos" element={<VideosPage />} />

                          {/* Route per admin */}
                          <Route
                            path="/users"
                            element={
                              <ProtectedRoute requiredRole="admin">
                                <div className="text-center py-12">
                                  <h2 className="text-2xl font-bold text-gray-900">
                                    Gestione Utenti
                                  </h2>
                                  <p className="mt-2 text-gray-600">
                                    Sezione in arrivo presto...
                                  </p>
                                </div>
                              </ProtectedRoute>
                            }
                          />

                          <Route
                            path="/settings"
                            element={
                              <ProtectedRoute requiredRole="admin">
                                <div className="text-center py-12">
                                  <h2 className="text-2xl font-bold text-gray-900">
                                    Impostazioni Sistema
                                  </h2>
                                  <p className="mt-2 text-gray-600">
                                    Sezione in arrivo presto...
                                  </p>
                                </div>
                              </ProtectedRoute>
                            }
                          />

                          {/* Route catch-all per 404 */}
                          <Route
                            path="*"
                            element={
                              <div className="text-center py-12">
                                <h2 className="text-2xl font-bold text-gray-900">
                                  Pagina non trovata
                                </h2>
                                <p className="mt-2 text-gray-600">
                                  La pagina che stai cercando non esiste.
                                </p>
                              </div>
                            }
                          />
                        </Routes>
                      </main>
                    </div>
                  </NotificationProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
        </SupabaseAuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
